import { isTiersVolumeProduct } from '@vy/services';
import type { UsageProduct, UsageProductInput } from '@vy/types';
import { outersect } from '@vy/utils';

export function getSplitVolumeUsageProducts<Product extends UsageProduct | UsageProductInput>(
  usageProducts: Product[],
) {
  const volumeBasedProducts = usageProducts.filter(isTiersVolumeProduct);
  const nonVolumeBasedProducts = outersect(usageProducts, volumeBasedProducts);

  return { volumeBasedProducts, nonVolumeBasedProducts } as const;
}
